<template>
    <div>
        <ul class="nav nav-tabs">
            <li class="nav-item" v-if="exercise.forum">
                <div class="nch--custom-tab" href="#" :class="{active: show}" @click="show = !show">
                    <i class="mdi mdi-forum"></i>
                    <span>{{$t('common.forum')}}</span>
                </div>
            </li>
        </ul>
        <slide-y-down-transition>
            <div v-show="show" class="container">
                <Forum
                    :name="exercise.translation.title"
                    :forum="exercise.forum"
                    :exercise="exercise"
                />
            </div>
        </slide-y-down-transition>
    </div>
</template>

<script>
import Forum from "../../components/Forum";
import { SlideYDownTransition } from "vue2-transitions";

export default {
    name: "ExerciseForumTab",
    components: {
        Forum,
        SlideYDownTransition
    },
    props: {
        exercise: Object
    },
    data() {
        return {
            show: false
        };
    }
};
</script>

<style scoped>
</style>
